import { useMemo } from 'react';

export const useBorrowProgress = (totalDeposited: string, totalDepositThreshold: string) => {
    return useMemo(
        () => Math.round((Number(totalDeposited) / Number(totalDepositThreshold)) * 100),
        [totalDeposited, totalDepositThreshold],
    );
};
